//  local
export const $authUrl = 'https://api.ladestellenbonus.at/'
export const serviceApi = 'https://api.ladestellenbonus.at/'
